/**
 * Признаки дефицита контекста в задаче. Каждый — наблюдаемый факт из трекера,
 * поэтому все они относятся к слою MEASURED.
 *
 * MISSING_DESCRIPTION и MISSING_ACCEPTANCE_CRITERIA засчитываются только при
 * несодержательном контенте: шаблон вида «TBD» или «см. тикет» покрытием не
 * считается.
 */
export var TaskQualityFlag;
(function (TaskQualityFlag) {
    TaskQualityFlag["MISSING_DESCRIPTION"] = "missing_description";
    TaskQualityFlag["MISSING_ACCEPTANCE_CRITERIA"] = "missing_acceptance_criteria";
    TaskQualityFlag["MISSING_PRIORITY"] = "missing_priority";
    TaskQualityFlag["MISSING_ESTIMATE"] = "missing_estimate";
    TaskQualityFlag["MISSING_ASSIGNEE"] = "missing_assignee";
    TaskQualityFlag["MISSING_EPIC_LINK"] = "missing_epic_link";
})(TaskQualityFlag || (TaskQualityFlag = {}));
//# sourceMappingURL=task-quality-flag.enum.js.map